import React, { ReactElement, useMemo } from 'react';
import debounce from 'lodash.debounce';
import Spinner from '../../../../components/Spinner';
import MedLink from '../../../../components/MedLink';
import EmptyView from '../../../../components/EmptyView';
import styles from './styles.module.scss';

interface Props {
  isEmpty: boolean;
  isInit?: boolean;
  children: ReactElement;
  className?: string;
  onReachEnd: () => void;
  renderFooter?: () => void | ReactElement;
  doctorId: number;
}

export default function ListContainter(props: Props): ReactElement {
  const { children, renderFooter, isEmpty, isInit, onReachEnd, doctorId } =
    props;
  const reachEnd = useMemo(() => debounce(onReachEnd, 500), [onReachEnd]);

  // 空数据组件
  const emptyViewText = useMemo(() => {
    return (
      <>
        <div className={styles.desc}>
          <span className={styles.first}>暂无处方</span>
          <span className={styles.second}>您当前未有满足续方条件的处方</span>
        </div>
        <MedLink path={`/chat/${doctorId}`}>
          <button className={styles.button}>立即联系医生开处方</button>
        </MedLink>
      </>
    );
  }, [doctorId]);

  if (isInit) {
    return <Spinner full />;
  }

  if (isEmpty) {
    return (
      <div className={styles.emptyWrap}>
        <EmptyView text={emptyViewText} />
      </div>
    );
  }

  return (
    <div className={styles.listWarp}>
      {/* @ts-ignore */}
      <div
        className={`${styles.list} ${props.className || ''}`}
        onScroll={(e: React.UIEvent<HTMLDivElement>) => {
          // @ts-ignore
          const { clientHeight, scrollHeight, scrollTop } = e.target;

          if (clientHeight + scrollTop >= scrollHeight - 50) {
            reachEnd();
          }
        }}
      >
        {children}
        {renderFooter && renderFooter()}
      </div>
    </div>
  );
}
